<div class="modal-content">
    <div class="modal-header">
      <h1 class="modal-title">
        <b> Alterar senha </b>
      </h1>
      <img src="/assets/icons/close.png" class="close" (click)="modalRef.hide()">
    </div>
  
    <div class="modal-body custom-scrollbar">
      <mat-label> Senha atual </mat-label>
      <input matInput placeholder="senha atual" [(ngModel)]="old_password"
        class="input" autocomplete="off" type="password">
  
        <mat-label> Nova senha </mat-label>
        <div style="position: relative;">
            <input matInput [type]="showNewPassword ? 'text' : 'password'"
            placeholder="nova senha" [(ngModel)]="new_password"
            class="input" autocomplete="off">
            <button type="button"
            (click)="showNewPassword = !showNewPassword"
            style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%);
                    background: none; border: none; cursor: pointer;">
            <span class="material-icons">
                {{ showNewPassword ? 'visibility_off' : 'visibility' }}
            </span>
            </button>
        </div>
        
  
      <mat-label> Confirmar nova senha </mat-label>
      <div style="position: relative;">
        <input matInput [type]="showConfirmPassword ? 'text' : 'password'"
          placeholder="confirmar senha" [(ngModel)]="confirm_password"
          class="input" autocomplete="off">
          <button type="button"
          (click)="showConfirmPassword = !showConfirmPassword"
          style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%);
                 background: none; border: none; cursor: pointer;">
          <span class="material-icons">
            {{ showConfirmPassword ? 'visibility_off' : 'visibility' }}
          </span>
        </button>
      </div>
    </div>
  
    <div style="text-align: center;">
      <button class="btn-yellow" mat-button (click)="checkPassword()">Salvar</button>
    </div>
  </div>
  